import { IStyleFunctionOrObject, ITextFieldProps, ITextFieldStyleProps, ITextFieldStyles, TextField } from '@fluentui/react';
import * as React from 'react';
import { BwjInput } from '../../entities/bwj-input';
import { BwjValidityState } from '../../entities/bwj-validity-state';
import { BwjSpinnerLabel } from '../bwj-spinner-label';
import { BwjWarningLabel } from '../bwj-warning-label';
import { BwjTextFieldType } from './field-type';

export interface IBwjTextFieldPropsUI {
  id: string;
  required: boolean;
  label?: string;
  placeholder?: string;
  onChange: React.FormEventHandler;
  onFocus: React.FormEventHandler;
  onBlur: React.FormEventHandler;
  input: BwjInput<string>;
  multiline?: boolean;
  fieldType?: BwjTextFieldType;
  styles?: IStyleFunctionOrObject<ITextFieldStyleProps, ITextFieldStyles> | undefined
  prefix: string | undefined;
  suffix: string | undefined;
  customPrefix: ((props: ITextFieldProps | undefined) => JSX.Element) | undefined;
  customSuffix: ((props: ITextFieldProps | undefined) => JSX.Element) | undefined;
}

export function BwjTextFieldUI(props: IBwjTextFieldPropsUI):JSX.Element {
  const multiline = !!props.multiline;
  const bwjProps = props;
  const stateMessage = [BwjValidityState.Indeterminate, BwjValidityState.Warning].indexOf(props.input.validity) !== -1 && !!props.input.message ? props.input.message : undefined;
  const error = (props.input.validity === BwjValidityState.Invalid || props.input.validity === BwjValidityState.ValidationError) && !!props.input.message ?
  props.input.message : undefined;

  const onRenderStateMessage = (props: ITextFieldProps | undefined) => {
    return (bwjProps.input.validity === BwjValidityState.Indeterminate ?
    <BwjSpinnerLabel text={props?.description} /> :
    <BwjWarningLabel text={props?.description} />);
  };

  return (
    <TextField  id={props.id}
                required={props.required}
                label={props.label}
                placeholder={props.placeholder}
                onChange={props.onChange}
                onFocus={props.onFocus}
                onBlur={props.onBlur}
                value={props.input.value}
                onRenderDescription={onRenderStateMessage}
                description={stateMessage}
                errorMessage={error}
                multiline={multiline}
                autoAdjustHeight={multiline}
                type={props.fieldType}
                styles={props.styles}
                canRevealPassword={props.fieldType === BwjTextFieldType.RevealablePassword}
                prefix={props.prefix}
                suffix={props.suffix}
                onRenderPrefix={props.customPrefix}
                onRenderSuffix={props.customSuffix}/>
  );
}